import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CircleIcon from '../CircleIcon';
import Flex from '../Flex';
import Icon from '../Icon';
import { mediaQueries } from '../../theme';

const { greaterThan } = mediaQueries;

const Wrapper = styled(Flex)`
  width:100%;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const InputWrapper = styled(Flex)`
  width:100%;
  max-width: ${(p) => p.theme.threshold.sectionMaxWidth};
  height: ${(p) => p.theme.space[10]};
  padding: 0 ${(p) => p.theme.space[5]};
  background-color: white;
  ${greaterThan[0]`
      width:auto;
      min-width: 450px;
      border-radius: ${(p) => p.theme.radii[2]};
      height: ${(p) => p.theme.space[8]};
    `}
`;

const ButtonWrapper = styled(Flex)`
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: ${(p) => p.theme.colors.secondary};
    min-width: ${(p) => p.theme.space[10]};
    min-height: ${(p) => p.theme.space[10]};
    ${greaterThan[0]`
      min-width: 45px;
      min-height: 45px;
      border-radius: 50%;
      margin-left:${(p) => p.theme.space[4]};
    `}
`;

const StyledInput = styled.input`
  appearance: none;
  border: 0;
  box-sizing: border-box;
  color: inherit;
  font-family: inherit;
  font-size: ${(p) => p.theme.fontSizes[2]};
  font-weight: ${(p) => p.theme.fontWeights.light};
  margin: 0;
  padding: 14px 12px;
  width: 100%;

  ::placeholder {
    color: ${(p) => p.theme.colors.base40};
  }
`;

const ResponsiveSearchBar = ({
  onChange, onButtonClick, placeHolder, withButton, defaultValue, ...rest
}) => {
  const [searchValue, setSearchValue] = useState(defaultValue || '');
  const inputRef = useRef();

  useEffect(() => {
    onChange(searchValue);
  }, [onChange, searchValue]);

  return (
    <Wrapper>
      <InputWrapper alignItems="center" flexDirection="row" {...rest}>
        {searchValue
          ? <CircleIcon bg="base60" color="white" name="Cross" iconSize="xs" onClick={() => { setSearchValue(''); inputRef.current.focus(); }} />
          : <Icon color="baseOpacity60" name="Search" size="16px" />}
        <StyledInput onChange={(evt) => setSearchValue(evt.currentTarget.value)} ref={inputRef} value={searchValue} placeholder={placeHolder} />
      </InputWrapper>
      {withButton && (
      <ButtonWrapper onClick={onButtonClick}>
        <Icon size="16px" name="Options" color="white" />
      </ButtonWrapper>
      )}
    </Wrapper>
  );
};

ResponsiveSearchBar.defaultProps = {
  placeHolder: 'Search by keyword',
  onButtonClick: () => {},
  withButton: true,
  defaultValue: '',
};

ResponsiveSearchBar.propTypes = {
  onChange: PropTypes.func.isRequired,
  onButtonClick: PropTypes.func,
  placeHolder: PropTypes.string,
  withButton: PropTypes.bool,
  defaultValue: PropTypes.string,
};

export default ResponsiveSearchBar;
